"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOUSE_EVENTS = void 0;
exports.MOUSE_EVENTS = {
    CLICK: 'click',
    KEYPRESS: 'keypress',
    MOUSEDOWN: 'mousedown',
    MOUSEMOVE: 'mousemove',
    SCROLL: 'scroll'
};
//# sourceMappingURL=MOUSE.js.map